/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { isTest } from '../useEnvironment';

// Define the shape of our context
interface FeatureFlagContextType {
  flags: {
    multipleFramingDecisionsEnabled: boolean;
  };
  toggles: {
    toggleMultipleFramingDecisions: () => void;
  };
}

// Create the context with a default value
export const FeatureFlagContext = createContext<FeatureFlagContextType>({
  flags: {
    multipleFramingDecisionsEnabled: false,
  },
  toggles: {
    toggleMultipleFramingDecisions: () => {},
  },
});

interface FeatureFlagProviderProps {
  children: ReactNode;
}

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({
  children,
}) => {
  const isTestEnv = isTest();
  const [multipleFramingDecisionsEnabled, setMultipleFramingDecisionsEnabled] =
    useState(false);

  const toggleMultipleFramingDecisions = useCallback(() => {
    if (isTestEnv) {
      setMultipleFramingDecisionsEnabled((prev) => !prev);
    }
  }, [isTestEnv]);

  const contextValue = {
    flags: {
      multipleFramingDecisionsEnabled: isTestEnv
        ? multipleFramingDecisionsEnabled
        : false,
    },
    toggles: {
      toggleMultipleFramingDecisions,
    },
  };

  return (
    <FeatureFlagContext.Provider value={contextValue}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
